import { CompletedTodo } from "shared/todos/CompletedTodo";

export const apiCompletedTodoIndexPath = "/api/completed_todo";
export type ApiCompletedTodoIndexResponse = CompletedTodo[];

export type ApiCompletedTodoCreateParams = {
  todo_id: number;
};
export type ApiCompletedTodoCreateResponse = CompletedTodo[];
export const apiCompletedTodoCreatePath = "/api/completed_todo";

export type ApiCompletedTodoCreateBulkResponse = CompletedTodo[];
export type ApiCompletedTodoCreateBulkParams = {
  todo_ids: number[];
};
export const apiCompletedTodoCreateBulkPath = "/api/completed_todo/bulk";
